import { colors } from "constants/colors";
import React from "react";

import { SpeachBalloon, SpeachBalloonProps } from "../SpeachBalloon";
import { StyledDateBotContainer } from "./styled";
import { Typography } from "components/parts/Typography/Typography";
import { getBotChatDate } from "utils/common";

export type DateBotProps = {
  createdAt: string;
} & SpeachBalloonProps;

export const DateBot: React.FC<DateBotProps> = ({ createdAt, border }) => {
  return (
    <StyledDateBotContainer>
      <SpeachBalloon background={colors.lightGray} border={border}>
        <Typography
          text={getBotChatDate(new Date(createdAt))} //TODO: createdAt（UTC）を動作環境のロケールに直している、JST固定にしたい
          size="xxsmall"
          color={"white"}
        />
      </SpeachBalloon>
    </StyledDateBotContainer>
  );
};
